import Lenis from "@studio-freight/lenis";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);
const animations = {
    init()  {

        // Function to check if the current browser is Safari
        function isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }

        // Initialize and use Lenis only if it's not Safari

            let lenis;
            lenis = new Lenis({
                duration: 0.8,
            });

            lenis.on('scroll', () => ScrollTrigger.update());

            function raf(time) {
                lenis.raf(time);
                requestAnimationFrame(raf)
                handleScrollAction()
            }
            const header = document.getElementById('masthead')
            requestAnimationFrame(raf);
            function handleScrollAction() {
                const scrollPosition = window.scrollY || document.documentElement.scrollTop;
                if (scrollPosition > 1) {
                    header.classList.add('scrolled');
                } else {
                    header.classList.remove('scrolled');
                }
            }


        // Find all links with href attributes that start with #
        const links = document.querySelectorAll('a[href^="#"]')

        links.forEach(link => {
            link.addEventListener('click', (event) => {
                // Prevent default anchor behavior
                event.preventDefault()

                // Get the target element's ID from the href attribute
                const targetId = link.getAttribute('href').substring(1)
                const targetElement = document.getElementById(targetId)

                if (targetElement) {
                    // Use Lenis to scroll to the target element
                    lenis.scrollTo(targetElement)
                }
            })
        })


        $(document).on('mouseenter', '.video-link', function() {
            // Play the video inside this anchor tag
            $(this).find('video').get(0).play();
        }).on('mouseleave', '.video-link', function() {
            // Pause the video inside this anchor tag
            $(this).find('video').get(0).pause();
        });
        $('.js-close-sub').on('click', function(){
            $('body').removeClass('active');
            if ($('body').hasClass('active')) {
                // The menu is open, so stop Lenis to allow scrolling within the menu
                lenis.destroy();
            } else {
                // The menu is closed, so start Lenis for smooth scrolling on the page
                lenis.start();
            }

        })
        $('.menu-item-has-children').on('click', function (){
            $('body').addClass('active');
            // Check if the menu is now open (has the 'active' class)
            if ($('body').hasClass('active')) {
                // The menu is open, so stop Lenis to allow scrolling within the menu
                lenis.destroy();
            } else {
                // The menu is closed, so start Lenis for smooth scrolling on the page
                lenis.start();
            }
        })


        if($('.trusted-by ul li')[0]){
            var $items = $('.trusted-by ul li'); // Cache the selection
            var itemCount = $items.length;       // Get the count of items

            // setTimeout(function(){
            //     if (itemCount > 0) { // Check if there are any items
            //         $items.css('width', (100 / itemCount) + '%'); // Set width as a percentage
            //     }
            // }, 400)
        }
        console.log($('.bio-block button').length);  // This should print the count of elements matched

       setTimeout(function(){
           $(' .bio-block button').on('click', function(e){
               e.preventDefault();
               var copyText = $('#textToCopy');

               // Select the text inside the text field
               copyText.select();
               copyText[0].setSelectionRange(0, 99999); // For mobile devices
               console.log(copyText[0])
               // Copy the text inside the text field to the clipboard
               document.execCommand('copy');
               $(this).html('<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                   '<path d="M2 7L8 13L20.5 2" stroke="#F3FAFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                   '</svg>\n Copied!');

           })
           $('input[type="email"]').on('keyup', function() {
               console.log('logging');
               const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
               var errorMessage = $(this).next('.error-message'); // Select the dynamically inserted paragraph

               if (emailPattern.test($(this).val())) {
                   $(this).removeClass('error');
                   errorMessage.hide();

               } else {
                   $(this).addClass('error');
                   errorMessage.show();

               }
           });
           $('input[type="email"]').each(function() {
               $('<p class="error-message">Please enter a valid email address.</p>').insertAfter(this);
           });
       }, 1200)

        $('.blurb-block button').on('click', function(e){
            e.preventDefault();
            var copyText = $('#textToCopyAlt');
            console.log(copyText);
            // Select the text inside the text field
            copyText.select();
            copyText[0].setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field to the clipboard
            document.execCommand('copy');
            $(this).html('<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M2 7L8 13L20.5 2" stroke="#F3FAFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                '</svg>\n Copied!');
        })
        $('.js-mobile-menu-trigger').on('click', function(){
            $('body').toggleClass('active-mobile');
            if ($('body').hasClass('active-mobile')) {
                // The menu is open, so stop Lenis to allow scrolling within the menu
                lenis.destroy();
            } else {
                // The menu is closed, so start Lenis for smooth scrolling on the page
                lenis.start();
            }
        })


        document.addEventListener('DOMContentLoaded', () => {
            const ctaLink = document.querySelector('.cta-link');

            function followMouse(event) {
                const bounding = ctaLink.getBoundingClientRect();
                const centerX = bounding.left + bounding.width / 2;
                const centerY = bounding.top + bounding.height / 2;

                let offsetX = (event.clientX - centerX) * 0.1; // Subtle follow effect
                let offsetY = (event.clientY - centerY) * 0.1; // Subtle follow effect

                gsap.to(ctaLink, {
                    x: offsetX,
                    y: offsetY,
                    duration: 0.3,
                    ease: 'power1.out'
                });
            }

            ctaLink.addEventListener('mouseenter', () => {
                document.addEventListener('mousemove', followMouse);
            });

            ctaLink.addEventListener('mouseleave', () => {
                document.removeEventListener('mousemove', followMouse);
                gsap.to(ctaLink, {
                    x: 0,
                    y: 0,
                    duration: 0.3,
                    ease: 'power1.out'
                });
            });
        });

    }
}

export {animations}